import { setWorkoutIds } from './setRoutine';

export const convertCsvFormat = (
  routines: any,
  challenge_id: string | undefined,
) => {
  return routines
    .filter((item: any) => item.name !== 'isRest')
    .map((routine: any) => {
      const workoutIds = setWorkoutIds(routine);

      return {
        id: typeof routine.id === 'string' ? undefined : routine.id,
        name: routine.name,
        workout_id: routine.workout_id,
        part: routine.part,
        condition_id: routine.challenge_condition?.id || null,
        condition_name: routine.challenge_condition?.name || '',
        condition_part: routine.challenge_condition?.part || '',
        condition_workout_id: routine.challenge_condition?.workout_id || null,
        date: routine.date,
        count: +routine.count,
        weight_multiplier: +routine.weight_multiplier,
        weight_kg: +routine.weight_kg,
        weight_lbs: +routine.weight_lbs,
        body_weight_multiplier: routine.body_weight_multiplier || null,
        count_placeholder: routine.count_placeholder,
        rir: routine.rir === '' ? null : routine.rir,
        weight_placeholder: routine.weight_placeholder,
        set_count: +routine.set_count,
        alt_workouts: workoutIds.join('-'),
        alt_workouts_part: routine.alt_workouts_part_id
          ? routine.alt_workouts_part_id
          : routine.alt_workouts_part,
        challenge_id,
        rest_time_sec: routine?.rest_time_sec || null,
        tip: routine.tip,
      };
    });
};

export default convertCsvFormat;
